module.exports = __webpack_public_path__ + "img/brainstorming.c04d1116.svg";